import { structureRoom } from '../lib/structureRoom';
import type { PublicFrame } from './TrendTimeline';

const format = (n: number) => n.toFixed(2);
const distance = (n: number | null | undefined, positive: string, negative: string) => n === null || n === undefined
  ? 'Pending' : `${format(Math.abs(n))} pts ${n >= 0 ? positive : negative}`;

export function StructureRoomCard({ frame, price, stale }: { frame: PublicFrame; price: number | null; stale: boolean }) {
  const room = structureRoom(frame, price, stale);
  return <div className="timeline-room">
    {room.direction ? <><div className="room-values">
      <span>Last {room.direction === 'bullish' ? 'higher' : 'lower'} high ({room.high?.label})<b>{room.high ? format(room.high.price) : 'Pending'}</b></span>
      <span>{stale ? 'Last price' : 'Current price'}<b>{price !== null && Number.isFinite(price) ? format(price) : 'Pending'}</b></span>
      <span>Last {room.direction === 'bullish' ? 'higher' : 'lower'} low ({room.low?.label})<b>{room.low ? format(room.low.price) : 'Pending'}</b></span>
    </div><div className="room-distances">
      <span>Last high <b>{distance(room.toHigh, 'below', 'above')}</b></span>
      <span>Last low <b>{distance(room.aboveLow, 'above', 'below')}</b></span>
    </div>{room.ratio !== null && room.ratio !== undefined
      ? <p>{room.direction === 'bullish' ? 'Uptrend' : 'Downtrend'} swing room/risk <b>{room.ratio.toFixed(2)}:1</b></p>
      : <p>{room.status}</p>}</>
      : <p>High and low lines have not both matched for two consecutive segments.</p>}
  </div>;
}
